import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, state } = useLocation();
  // Set only by the developer portfolio's language switch, which restores
  // the reader's position itself (see src/pages/hire/hireScrollMemory.js).
  const keepScroll = Boolean(state && state.hireKeepScroll);

  useEffect(() => {
    if (keepScroll) return;
    window.scrollTo(0, 0);
  }, [pathname, keepScroll]);

  return null;
}